import React from "react";
import RosterSettingsComponent from "../components/rosterSettings/RosterSettingsComponent";

const RosterSettingsContainer = () => {
  return <RosterSettingsComponent />;
};

export default RosterSettingsContainer;
